<template>
    <div id="login">
        <h1>Login</h1>
        <input type="text" name="username" v-model="userinfo.username" placeholder="Username"/>
        <input type="password" name="password" v-model="userinfo.password" placeholder="Password"/>
        <button type="button" @click="login()">Login</button>
    </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      userinfo: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    login () {
      if (this.userinfo.username !== '' && this.userinfo.password !== '') {
        if (this.userinfo.username === this.$parent.acountinfo.username && this.userinfo.password === this.$parent.acountinfo.password) {
          // this.$parent.setAuthenticated(true);
          // this.$emit('authenticated', true) //Gán cho sự kiện authenticated giá trị true
          // this.$router.replace({name: 'Secure'});
          this.$session.start()
          this.$session.set('username', this.userinfo.username)
          this.$router.push('/secure')
        } else {
          alert('The username or password is incorrect')
        }
      } else {
        alert('User and Password must be present')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue